<div class="mb-3">
    <label class="form-label">{{ label }}</label>
    <input type="file" accept="image/*" class="form-control" (change)="onFileChange($event)" />
  
    <!-- Preview -->
    <div *ngIf="previewUrl" class="mt-3">
      <p class="mb-1">Preview:</p>
      <img [src]="previewUrl" alt="Preview" style="max-width: 200px; border-radius: 6px;" />
    </div>
  
    <!-- Validation Errors -->
    <div class="text-danger mt-2" *ngIf="file">
      <div *ngIf="file.size > maxSizeMB * 1024 * 1024">❌ Max size is {{ maxSizeMB }}MB</div>
      <div *ngIf="!allowedTypes.includes(file.type)">❌ Allowed types: jpg, png, gif</div>
    </div>
  </div>
  
